
// constants as defined in RevoXef’s App\Models\Orders\OrderInvoice
const STANDARD = 0
const SPLIT_ITEMS = 1
const SPLIT_PERSONS = 2

export default {
  STANDARD,
  SPLIT_ITEMS,
  SPLIT_PERSONS,
}
